'use client';
import { useState, useEffect, useRef } from 'react';

export const useDetectWrap = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isWrapped, setIsWrapped] = useState(false);

  useEffect(() => {
    const checkWrap = () => {
      if (ref.current) {
        const parent = ref.current.parentElement;
        if (parent) {
          const parentTop = parent.getBoundingClientRect().top;
          const elementTop = ref.current.getBoundingClientRect().top;
          setIsWrapped(Math.abs(elementTop - parentTop) > 30); // Using 1px threshold for safety
        }
      }
    };

    // Defer initial check to next frame to avoid hydration timing issues
    const rafId = requestAnimationFrame(checkWrap);

    let lastWidth = window.innerWidth;
    const handleResize = () => {
      // Skip height-only changes (mobile browser chrome appearing/disappearing)
      const currentWidth = window.innerWidth;
      if (currentWidth === lastWidth) return;
      lastWidth = currentWidth;
      checkWrap();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { ref, isWrapped };
};
